module.exports = __webpack_public_path__ + "static/media/scaffolder-video-001.22a68ce4.mp4";